// src/pages/Marketplace/shared/useBusinessMarketOverride.ts
import { useState } from 'react';

export function useBusinessMarketOverride(apiUrl: string, accessToken: string | null) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setOverride = async (businessId: string, marketId: string | null): Promise<boolean> => {
    setLoading(true); setError(null);
    try {
      const res = await fetch(`${apiUrl}/admin/businesses/${businessId}/market-override`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ marketId }),
      });
      if (!res.ok) throw new Error((await res.text()) || `PUT override ${res.status}`);
      return true;
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Unknown error'); return false;
    } finally { setLoading(false); }
  };

  return { loading, error, setOverride };
}
